import React from 'react';
import { Container, Row, Col} from 'reactstrap';

export default class VimeoIframe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: '100%',
      height: '100%',
      src: this.props.links.vimeo
    }
    this.updateIframeDimensions = this.updateIframeDimensions.bind(this);
  }
  componentWillMount() {
    this.updateIframeDimensions();
  }
  componentDidMount() {
    this.updateIframeDimensions();
    window.addEventListener('resize', this.updateIframeDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIframeDimensions);
  }
  updateIframeDimensions() {
    if (window.innerWidth > 520) {
      this.setState({ height: '550' })
    } else {
      this.setState({ height: '100%' })
    }
  }
  render() {
    return (
      <Container className="p-1">
        <Row className="text-center no-gutters">
          <Col>
            <iframe title={this.props.title} src={this.state.src} width={this.state.width} height={this.state.height} frameBorder="0" webkitallowfullscreen="true" mozallowfullscreen="true"
              allowFullScreen="true"></iframe>
          </Col>
        </Row>
      </Container>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ProjectPage/VimeoIframe/VimeoIframe.js